module.exports = __webpack_public_path__ + "media/images/error/503-0118d6a65a2a462a686e300b2643ded0.png";